export default __webpack_public_path__ + "static/media/strategy.d1c02542.svg";